import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowBack } from '@mui/icons-material';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="mt-4 text-3xl font-extrabold text-gray-900">Page non trouvée</h2>
        <p className="mt-2 text-sm text-gray-600">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="mt-6 flex justify-center space-x-4">
          <Link
            to="/"
            className="btn btn-primary flex items-center space-x-2"
          >
            <Home className="w-5 h-5" />
            <span>Accueil</span>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="btn btn-outline flex items-center space-x-2"
          >
            <ArrowBack className="w-5 h-5" />
            <span>Retour</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
